import config from 'config/index';
import { API_ROUTES, LOCALSTORAGE_KEYS } from 'utils/globalVariable';
import { callApi, getItem, getHotelId } from 'utils/globalFunction';

export const getAnnouncements = async (postData: any = {}): Promise<any> => {
  try {
    const hotelId = getHotelId() as string;
    const announcements = await callApi(
      `${config.REACT_APP_BASE_URL}${API_ROUTES.baseWorkspaceUrl}/${hotelId}/announcements`,
      postData,
      'get',
      true,
      false,
      getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
      '',
      false,
    );

    if (announcements?.data?.data?.announcements) {
      return announcements.data.data.announcements;
    } else {
      return [];
    }
  } catch (error: any) {
    return [];
  }
};

export const getUserAnnouncements = async (
  postData: any = {},
): Promise<any> => {
  try {
    const hotelId = getHotelId() as string;
    const announcements = await callApi(
      `${config.REACT_APP_BASE_URL}${API_ROUTES.baseWorkspaceUrl}/${hotelId}/announcements/logs`,
      postData,
      'get',
      true,
      false,
      getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
      '',
      false,
    );

    if (announcements?.data?.data) {
      return announcements.data.data;
    } else {
      return [];
    }
  } catch (error: any) {
    return [];
  }
};

export const getAnnouncement = async (postData: any = {}): Promise<any> => {
  try {
    const hotelId = getHotelId() as string;
    const announcement = await callApi(
      `${config.REACT_APP_BASE_URL}${API_ROUTES.baseWorkspaceUrl}/${hotelId}/announcements/${postData.announcementId}`,
      {},
      'get',
      true,
      false,
      getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
      '',
      false,
    );

    if (announcement?.data?.data?.announcement) {
      return announcement.data.data.announcement;
    } else {
      return [];
    }
  } catch (error: any) {
    return [];
  }
};

export const createAnnouncement = async (postData: any = {}): Promise<any> => {
  try {
    const hotelId = getHotelId() as string;
    const announcement = await callApi(
      `${config.REACT_APP_BASE_URL}${API_ROUTES.baseWorkspaceUrl}/${hotelId}/announcements`,
      postData,
      'post',
      true,
      false,
      getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
      '',
      false,
    );

    if (announcement?.data?.data?.announcement) {
      return announcement.data.data.announcement;
    } else {
      return null;
    }
  } catch (error: any) {
    return null;
  }
};

export const updateAnnouncement = async (
  postData: any = {},
  announcementId: string,
): Promise<any> => {
  try {
    const hotelId = getHotelId() as string;
    const announcement = await callApi(
      `${config.REACT_APP_BASE_URL}${API_ROUTES.baseWorkspaceUrl}/${hotelId}/announcements/${announcementId}`,
      postData,
      'put',
      true,
      false,
      getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
      '',
      false,
    );

    return announcement;
  } catch (error: any) {
    return null;
  }
};

export const getAnnouncementLogs = async (postData: any = {}): Promise<any> => {
  try {
    const hotelId = getHotelId() as string;
    const announcementLogs = await callApi(
      `${config.REACT_APP_BASE_URL}${API_ROUTES.baseWorkspaceUrl}/${hotelId}/announcements/logs`,
      postData,
      'get',
      true,
      false,
      getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
      '',
      false,
    );

    if (announcementLogs?.data) {
      return announcementLogs.data;
    } else {
      return [];
    }
  } catch (error: any) {
    return [];
  }
};

export const deleteAnnouncement = async (
  announcementId: string,
): Promise<any> => {
  try {
    const hotelId = getHotelId() as string;
    const announcement = await callApi(
      `${config.REACT_APP_BASE_URL}${API_ROUTES.baseWorkspaceUrl}/${hotelId}/announcements/${announcementId}`,
      {},
      'delete',
      true,
      false,
      getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
      '',
      false,
    );

    return announcement;
  } catch (error: any) {
    return null;
  }
};

export const removeAnnouncement = async (
  announcementId: string,
): Promise<any> => {
  try {
    const hotelId = getHotelId() as string;
    const announcement = await callApi(
      `${config.REACT_APP_BASE_URL}${API_ROUTES.baseWorkspaceUrl}/${hotelId}/announcements/${announcementId}/expire`,
      {},
      'POST',
      true,
      false,
      getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
      '',
      false,
    );

    return announcement;
  } catch (error: any) {
    return null;
  }
};

export const openAnnouncement = async (
  announcementId: string,
): Promise<any> => {
  try {
    const hotelId = getHotelId() as string;
    const announcement = await callApi(
      `${config.REACT_APP_BASE_URL}${API_ROUTES.baseWorkspaceUrl}/${hotelId}/announcements/${announcementId}/open`,
      {},
      'post',
      true,
      false,
      getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
      '',
      false,
    );

    return announcement;
  } catch (error: any) {
    return null;
  }
};

export const acknowledgeAnnouncement = async (
  postData: any = {},
  announcementId: string,
  finish = false,
): Promise<any> => {
  try {
    const hotelId = getHotelId() as string;
    const announcement = await callApi(
      `${config.REACT_APP_BASE_URL}${API_ROUTES.baseWorkspaceUrl}/${hotelId}/announcements/${announcementId}/acknowledge?finish=${finish}`,
      postData,
      'post',
      true,
      false,
      getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
      '',
      false,
    );

    return announcement;
  } catch (error: any) {
    return null;
  }
};

export const sendReminder = async (announcementId: string): Promise<any> => {
  try {
    const hotelId = getHotelId() as string;
    const announcement = await callApi(
      `${config.REACT_APP_BASE_URL}${API_ROUTES.baseWorkspaceUrl}/${hotelId}/announcements/${announcementId}/reminder`,
      {},
      'post',
      true,
      false,
      getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
      '',
      false,
    );

    if (announcement?.data?.data?.announcement) {
      return announcement.data.data.announcement;
    } else {
      return null;
    }
  } catch (error: any) {
    return null;
  }
};

export const getAnnouncementExcelReport = async (
  announcementId: string,
): Promise<any> => {
  try {
    const hotelId = getHotelId() as string;
    const announcement = await callApi(
      `${config.REACT_APP_BASE_URL}${API_ROUTES.baseWorkspaceUrl}/${hotelId}/announcements/${announcementId}/excel`,
      {},
      'get',
      true,
      false,
      getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
      '',
      false,
    );

    if (announcement?.data?.data) {
      return announcement.data.data;
    } else {
      return null;
    }
  } catch (error: any) {
    return null;
  }
};
